import React from 'react';

import { tv } from '@eluve/components';

const styles = tv({
  base: 'inline-flex shrink-0 rounded-md px-2 py-1 text-nowrap',
  variants: {
    type: {
      CPT: 'bg-bg-teal-strong text-text-teal-strong',
      ICD_10: 'bg-bg-lightblue-strong text-text-lightblue-strong',
      ICD_9: 'bg-bg-orange-strong text-text-orange-strong',
      SNOMED: 'bg-bg-purple-strong text-text-purple-strong',
      HCPCS: 'bg-bg-lightgreen-strong text-text-lightgreen-strong',
      MBS: 'bg-bg-yellow-strong text-text-yellow-strong',
    },
  },
});

export type CodeType = 'ICD_10' | 'ICD_9' | 'CPT' | 'SNOMED' | 'HCPCS' | 'MBS';

export interface MedicalCodeTypeBadgeProps {
  codeType: CodeType;
  label?: string;
}

export const MedicalCodeTypeBadge = React.forwardRef<
  HTMLDivElement,
  MedicalCodeTypeBadgeProps
>(({ codeType, label }, ref) => {
  const className = styles({
    type: codeType,
    className: 'text-2xs font-semibold text-text-primary',
  });

  return (
    <div ref={ref} className={className}>
      {label ?? codeType.replace('_', '-')}
    </div>
  );
});
